import * as React from "react";
import type { SVGProps } from "react";
const SvgLogoGray = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16" {...props}
  >
    <path
      fill="#A4ADBE"
      d="M1.484 15.91h.446c.718 0 1.367-.29 1.838-.756a2.56 2.56 0 0 0 .761-1.824v-2.42a1.32 1.32 0 0 1 .552-1.075.148.148 0 0 0-.106-.253H4.53a2.6 2.6 0 0 0-1.838.754 2.57 2.57 0 0 0-.761 1.826v2.419a1.33 1.33 0 0 1-.538 1.064.15.15 0 0 0-.058.116.15.15 0 0 0 .15.149"
    />
    <path
      fill="#A4ADBE"
      d="M4.666 15.91h.447c.717 0 1.367-.29 1.837-.756a2.56 2.56 0 0 0 .762-1.824V7.745a1.32 1.32 0 0 1 .551-1.075.148.148 0 0 0-.105-.252h-.446a2.6 2.6 0 0 0-1.838.754 2.57 2.57 0 0 0-.761 1.825v5.584c0 .43-.209.816-.53 1.058l-.009.006a.15.15 0 0 0-.057.117c0 .082.068.148.15.148"
    />
    <path
      fill="#A4ADBE"
      d="M7.846 15.91h.446a2.6 2.6 0 0 0 1.838-.756 2.56 2.56 0 0 0 .761-1.824V4.58a1.32 1.32 0 0 1 .552-1.074.148.148 0 0 0-.105-.253h-.447a2.6 2.6 0 0 0-1.838.754 2.57 2.57 0 0 0-.76 1.825v8.749c0 .43-.209.815-.53 1.058q-.004.004-.01.006a.15.15 0 0 0-.056.117c0 .082.067.148.149.148"
    />
    <path
      fill="#A4ADBE"
      d="M11.027 15.91h.446a2.6 2.6 0 0 0 1.838-.756 2.56 2.56 0 0 0 .761-1.824V1.417a1.32 1.32 0 0 1 .552-1.074.148.148 0 0 0-.105-.253h-.447a2.6 2.6 0 0 0-1.837.754 2.57 2.57 0 0 0-.762 1.825v11.912a1.33 1.33 0 0 1-.538 1.064.15.15 0 0 0-.057.117c0 .082.067.148.149.148"
    />
  </svg>
);
export default SvgLogoGray;
